import { twMerge } from 'tailwind-merge';

interface PdfFormFieldValueProps {
  text: string;
  textClassName?: string;
}

export const PdfFormFieldValue = ({
  text,
  textClassName,
}: PdfFormFieldValueProps) => {
  return (
    <div className={twMerge('text-2sm font-thin break-all', textClassName)}>
      {text}
    </div>
  );
};
